var Newsletter = {};


//--------------
// Functions
//--------------

/**
 * [subscribeNewsletter description]
 * @return {[type]} [description]
 */
Newsletter.subscribe = function(){
	var email = $('#newsletter-email').val();

	$.post({
		url: '/api/newsletter/subscribe',
    type: 'POST',
    data: { email: email }
  })
	.done(function(data) {
		$('.js-form-newsletter')[0].reset();
		// Todo @front : Afficher un message de succès
		App.successMessage('.js-form-newsletter');
  })
  .fail(function(err) {
  	console.log('-- Error', err);
		App.errorMessage('.js-form-newsletter');
  });
}


//--------------
// Execution
//--------------

// Subscribe to newsletter
$('.js-form-newsletter').submit(function(){
	if(!$(this).valid())
		return false;

	var honey = $('#newsletter-name').val();

	if(honey){
		$('.js-form-newsletter')[0].reset();
	} else {
		Newsletter.subscribe();
	}

	return false;
});

module.exports = Newsletter;